import {IPlaneCategory} from "../../../store/reducers/fleetReducer/fleetReducerTypes";
import {IntlShape} from "react-intl";

const getNotIndicatedMessage = (intl: IntlShape): string => {
  return intl.formatMessage({
    id: "displayHelpers.displayPlaneCategories.notIndicated",
    defaultMessage: "Not specified"
  });
}

export const DisplayPlaneCategories = (planeCategories: IPlaneCategory[], intl?: IntlShape): string => {
  if (planeCategories.length === 0) {
    if (intl) {
      return getNotIndicatedMessage(intl);
    }
    return "Not specified";
  }

  return planeCategories.map(category => category.name).join(', ')
}